import { Grid, Table, TableBody, TableHead, TableRow } from '@mui/material';
import useSWR from 'swr';

import { formatString, queryParams } from '@shared/commonFunctions';
import { Modal } from '@shared/components/modals/Modal';
import { SERVICES } from '@shared/constants/apiConfig';
import { StyledTableCell } from '@styles/ContactManager/DealStyles';

interface ISalesTaxInfoModalProps {
  open: boolean;
  handleClose: () => void;
}

export const SalesTaxInfoModal = ({ open, handleClose }: ISalesTaxInfoModalProps) => {
  const { data } = useSWR(`${SERVICES.CONTACT}/contacts/${queryParams().id}/taxreference`);
  const keys = data && Object.keys(data);

  return (
    <Modal
      open={open}
      title="Regional Taxes"
      dialogWidth="350px"
      onClose={handleClose}
    >
      <Grid container>
        <Grid item md={12} padding={2}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell style={{ fontWeight: 'bold' }}>Title</StyledTableCell>
                <StyledTableCell style={{ fontWeight: 'bold' }}>Taxes</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {keys?.map((el: string) => {
                return (
                  <TableRow key={el}>
                    <StyledTableCell>{formatString(el.replace(/([A-Z])/g, ' $1').trim())}</StyledTableCell>
                    <StyledTableCell>{Number(data[el])?.toFixed(2)}%</StyledTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </Modal>
  );
};
